import React from 'react';
import styled from 'styled-components';
import AccordionMenu from '@westwing/ui-kit/Accordion';
import useTranslator from 'Client/hooks/useTranslator';
import { body1, body2, header3 } from '@westwing/ui-kit/typography';
import useConfig from 'AppShell/hooks/useConfig';
import ClubHybridLink from 'Club/components/Links/ClubHybridLink';
import { forDesktop } from '@westwing/ui-kit/breakPoints';

const StyledAccordionMenu = styled(AccordionMenu)`
    border-top: 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.charcoal20New};
    ${forDesktop`
        border-top: 1px solid ${({ theme }) => theme.colors.charcoal20New};
        border-bottom: 0;
        margin-top: 32px;
    `}
`;

const AccordionContentWrapper = styled.div`
    margin: 15px 0 32px;
    grid-template-columns: 1fr;
    gap: 20px;
    display: grid;
    ${forDesktop`
       grid-template-columns: 1fr 1fr;
    `}
`;

const Title = styled.div`
    ${body1}
    color: ${({ theme }) => theme.colors.charcoal100};
    margin: 0;
`;

const SubTitle = styled.div`
    ${header3}
    font-size: 14px;
    color: ${({ theme }) => theme.colors.charcoal100};
    margin-bottom: 8px;
    ${forDesktop`
       font-size: 16px;
       margin-bottom: 12px;
    `}
`;

const LinkBlock = styled.div``;
const LinkBlockLinks = styled.ul`
    padding-right: 65px;
    display: flex;
    flex-wrap: wrap;
    column-gap: 20px;
    row-gap: 8px;
`;
const LinkBlockLinksItem = styled.li``;

const StyledHybridLink = styled(ClubHybridLink)`
    ${body2}
    color: ${({ theme }) => theme.colors.charcoal60};
    text-decoration: underline;
`;

export const FooterSeoLinks = () => {
    const t = useTranslator();
    const trackAccordion = () => {};
    const { links } = useConfig();
    return (
        <StyledAccordionMenu
            renderTitle={() => <Title aria-label={t('Footer_Ratgeber')}>{t('Footer_Ratgeber')}</Title>}
            clickHandler={trackAccordion}
        >
            <AccordionContentWrapper>
                {Object.entries(links.footerSeo).map(([title, links]) => (
                    <LinkBlock key={title}>
                        <SubTitle>{title}</SubTitle>
                        <LinkBlockLinks aria-label={title}>
                            {Object.entries(links).map(([text, url]) => (
                                <LinkBlockLinksItem key={`${title}_${url}`}>
                                    <StyledHybridLink to={url}>{text}</StyledHybridLink>
                                </LinkBlockLinksItem>
                            ))}
                        </LinkBlockLinks>
                    </LinkBlock>
                ))}
            </AccordionContentWrapper>
        </StyledAccordionMenu>
    );
};
